import { slice } from './slice';

const { reducer, actions } = slice;

export const { reset: resetGame } = actions;

export * from './thunks';
export * as currentGameSelectors from './selectors';

export default reducer;
